import React, {useState} from "react";

//components:
import MetricsTable from "./Table";
import MetricsNetgraph from "./Netgraph";
import TopDropdowns from "./TopDropdowns";

const InsightsMetrics = ({pageToShow}) => {
    const [selectedTrackMetrics, setSelectedTrackMetrics] = useState([]);
    const [selectedInsights, setSelectedInsights] = useState([]);
    const [filteredRankingTopics, setFilteredRankingTopics] = useState([]);

    return (
        <>
            <TopDropdowns
                selectedTrackMetrics={selectedTrackMetrics}
                selectedInsights={selectedInsights}
                setSelectedTrackMetrics={setSelectedTrackMetrics}
                setSelectedInsights={setSelectedInsights}
                setFilteredRankingTopics={setFilteredRankingTopics}
            />
            <div className="d-flex position-relative min-h-300px">
                {pageToShow === "netgraph" ? <MetricsNetgraph selectedInsights={selectedInsights} /> : null}
                {pageToShow === "table" ? <MetricsTable features={filteredRankingTopics} /> : null}
            </div>
        </>
    );
};

export default InsightsMetrics;
